import React from 'react';

const Avatar = ({
  size,
  online,
  offline,
  rounded,
  roundedCircle,
  title,
  src,
  className,
}) => {
  let divClass = `avatar ${className} `;
  let imgClass = 'avatar-img ';
  let spanClass = 'avatar-title ';

  if (size !== undefined && size !== 'md') {
    divClass += `avatar-${size} `;
  }

  if (online !== undefined && offline === undefined) {
    divClass += 'avatar-online ';
  } else if (online === undefined && offline !== undefined) {
    divClass += 'avatar-offline ';
  }

  if (rounded !== undefined && roundedCircle === undefined) {
    imgClass += 'rounded ';
    spanClass += 'rounded ';
  } else if (rounded === undefined && roundedCircle !== undefined) {
    imgClass += 'rounded-circle ';
    spanClass += 'rounded-circle ';
  }

  if (src !== undefined) {
    return (
      <div className={divClass}>
        <img src={src} className={imgClass} alt="..." />
      </div>
    );
  }

  if (title !== undefined && src === undefined) {
    return (
      <div className={divClass}>
        <span className={spanClass}>{title}</span>
      </div>
    );
  }

  return (
    <div className={divClass} />
  );
};

export default Avatar;
